import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { HeaderFlags } from '@/store/ui';
import { OrderType, PreConfiguredMeal, MealType, RecentOrFavoriteOrder } from '@/models';
import { Order, OrderWithContext, OrderStatus, Restaurant } from '@/models';
import { Routes, doesRouteRequireGroupOrderRestaurant } from '@/router';
import { GETTERS as CUSTOMER_GETTERS } from '@/store/customer';

@Component({
  name: 'GroupOrderMenu',
  beforeRouteLeave(to, from, next) {
    this.$services.ui.popHeaderState();
    //this.$services.order.setIsGroupOrderParticipant(false);
  
    if (!doesRouteRequireGroupOrderRestaurant(to)) {
      this.$services.restaurant.selectRestaurant(this.$appStore.state.restaurant.preGroupOrderFlowRestaurant, this.$services.order.isPickingUp());
    }

    next();
  },
})
export default class GroupOrderMenu extends Vue {

  participantName: string | null = null;

  get message(): string {
    return `hey ${this.participantName}, you joined ${this.$appStore.state.order.pendingGroupOrder?.order.customerFirstName}'s order.`;
  }

  get orderType(): OrderType {
    return OrderType.Group;
  }

  get featuredData(): PreConfiguredMeal[] {
    return this.$appStore.state.menu.preConfiguredMeals.filter(meal => meal.mealType == MealType.Influencer);
  }

  get isLoggedIn(): boolean {
    return this.$services.customer.isLoggedIn() === true;
  }

  get recentOrders(): RecentOrFavoriteOrder[] {
    return this.$appStore.getters[CUSTOMER_GETTERS.RECENT_ORDERS];
  }

  get favoriteOrders(): RecentOrFavoriteOrder[] {
    return this.$appStore.getters[CUSTOMER_GETTERS.FAVORITE_ORDERS];
  }
  
  async mounted() {
    this.$services.ui.pushHeaderState({ flags: HeaderFlags.Bag | HeaderFlags.LogoVisibleXS });

    let groupName = localStorage.getItem('groupName') || this.$appStore.state.order.groupOrderParticpantName;
    this.$services.order.setPendingGroupOrderName(groupName || '');
    this.participantName = groupName;

    this.$services.order.setIsGroupOrderParticipant(true);

    if (!this.$appStore.state.restaurant.selectedRestaurant) {
      this.$services.logger.error('group order restaurant selection is broken');
      return;
    }
    this.$services.menu.refreshPreConfiguredMeals(this.$appStore.state.restaurant.selectedRestaurant.restaurantNumber);

    Vue.nextTick(() => (this.$refs['groupOrderWelcome'] as HTMLElement).focus());
  }
}
